import React from 'react'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux'
import { hideModal } from '../../store/actions/index'
import { useTranslation } from 'react-i18next';

const AlertModal = (props) => {

  const { t } = useTranslation();

  return (
    <Modal show={true} onHide={props.hideModal} animation={true} size="lg">
      <div className="modal-header">
        <h5 className="modal-title">{props.modalTitle}</h5>
        <button onClick={props.hideModal} type="button" className="close btn btn-round" data-dismiss="modal" aria-label="Close">
          <i className="material-icons">close</i>
        </button>
      </div>
      <Modal.Body>
      { props.children }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.hideModal}>
          { t('modals.common.button.close') }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}


const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal())
})

export default connect(null, mapDispatchToProps)(AlertModal)



// WEBPACK FOOTER //
// ./src/components/Modals/AlertModal.js